module.exports = __webpack_public_path__ + "static/media/ReactJS_Badge.8e67079e.png";